/**
 * Configuration constants.
 * Used for quickly changing settings for different games.
 */
class Config
{
    constructor()
    {
        this.socketUrl = "http://api.cd2.d.skywind-tech.com:4001";

        this.gameId = "sw-fufish";

        this.viewPadSize = 20;
        this.halfViewPadSize = this.viewPadSize * .5;

        this.portraitAssets =
        {
            'hand' : 'hand.png',
            'room1_1' : 'room1_1.json',
            'room1_2' : 'room1_2.json',
            'room2_1' : 'room2_1.json',
            'room2_2' : 'room2_2.json',
            'room3_1' : 'room3_1.json',
            'room3_2' : 'room3_2.json',
            'room3_3' : 'room3_3.json',
            'room3_4' : 'room3_4.json',
            'lobby_1' : 'lobby_1.json',
            'lobby_2' : 'lobby_2.json',
            'atlas1' : 'sheet1.json',
            'atlas2' : 'PaytableAtlas.json',

            // Mother of Moons:
            'motmSke' : 'mothermoon_animation_all_hand_ske.json',
            'motmTex' : 'mothermoon_animation_all_hand_tex.json',
            'motmAtlas' : 'mothermoon_animation_all_hand_tex.png'
        }

        this.landscapeAssets =
        {

        }
    }
}

export default Config